import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goToPost } from 'actions/posts'
import ArticleListTags from 'components/ArticleListTags'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'

const TaggedPostsList = ({
  tag,
  loading,
  error,
  order,
  content,
  entities,
  onPostClick
}) => {
  const loaded = content
    ? {
        content,
        order,
        onPostClick
      }
    : null
  return (
    <LoadingLoadedOrExploded
      loading={loading}
      error={error && error.message}
      loaded={loaded}
      loadedComponent={ArticleListTags}
    />
  )
}

const mapStateToProps = ({
  location: { payload: { tag } },
  posts: {
    extra: entities,
    map: content,
    list: { loading, error, values: order, range } = {}
  }
}) => {
  return { tag, content, order, range, loading, error, entities }
}

const mapDispatchToProps = dispatch => ({
  onPostClick: ({ name, author: { username }, group, _id }) => {
    dispatch(goToPost({ name, username, group, _id }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(TaggedPostsList)
